import React, { useState } from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Charts from 'components/Charts';
import { BoxWrapper } from 'components/Base';
import { compose } from 'redux-starter-kit';
import { connect } from 'react-redux';
import Store from 'store/store';
const { selectors } = Store;

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  container: {
    flexWrap: 'wrap'
  },
  chartBox: {
    height: '100%',
    padding: '2rem'
  }
});
interface RegionalBreakdownProps {
  existingOnly?: boolean;
  regionalBreakdown: any;
  existingRegionalBreakdown: any;
}

const RegionalBreakDown = ({
  existingOnly = false,
  regionalBreakdown,
  existingRegionalBreakdown
}: RegionalBreakdownProps) => {
  const classes = useStyles();
  const applicableBreakdown = existingOnly
    ? existingRegionalBreakdown
    : regionalBreakdown;
  const [equity] = useState(
    applicableBreakdown.equity &&
      applicableBreakdown.equity
        .sort((a: any, b: any) => b.Existing - a.Existing)
        .filter((allocation: any) => allocation.Existing !== 0)
  );
  const [fixedIncome] = useState(
    applicableBreakdown.fixed_income &&
      applicableBreakdown.fixed_income
        .sort((a: any, b: any) => b.Existing - a.Existing)
        .filter((allocation: any) => allocation.Existing !== 0)
  );
  const [isLoading] = useState(applicableBreakdown.length < 0);

  return (
    <>
      {isLoading ? (
        <div className={classes.loaderWrapper}>
          <CircularProgress size="80px" />
        </div>
      ) : (
        <>
          <Grid container spacing={2} className={classes.container}>
            <Grid item md={6} className={classes.chartBox}>
              <BoxWrapper title="Equity Breakdown" style={{ padding: '1rem' }}>
                <Charts.Recommendation.AssetAllocation
                  data={equity}
                  hasExistingPolicies={true}
                  existingOnly={existingOnly}
                />
              </BoxWrapper>
            </Grid>
            <Grid item md={6} className={classes.chartBox}>
              <BoxWrapper
                title="Fixed Income Breakdown"
                style={{ padding: '1rem' }}
              >
                <Charts.Recommendation.AssetAllocation
                  data={fixedIncome}
                  hasExistingPolicies={true}
                  existingOnly={existingOnly}
                />
              </BoxWrapper>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default compose(
  connect((state: any) => ({
    regionalBreakdown: selectors.caseSelectors.regionlBreakdown(state),
    existingRegionalBreakdown:
      selectors.caseSelectors.existingRegionlBreakdown(state)
  }))
)(RegionalBreakDown);
